




















































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Prop, Vue } from 'vue-property-decorator';
import LayoutContent from '@/components/LayoutContent.vue';
import Button from '@/components/Button.vue';
import { apiProduction, apiSandbox } from '@/libs/api';

import BcaVA from '@/pages/Integration/Form/BcaVA.vue';
import BriVA from '@/pages/Integration/Form/BriVA.vue';
import MandiriBP from '@/pages/Integration/Form/MandiriBP.vue';
import BniVA from '@/pages/Integration/Form/BniVA.vue';
import BncVA from '@/pages/Integration/Form/BncVA.vue';
import PermataVA from '@/pages/Integration/Form/PermataVA.vue';
import DanamonVA from '@/pages/Integration/Form/DanamonVA.vue';
import MaybankVA from '@/pages/Integration/Form/MaybankVA.vue';
import BAGIVA from '@/pages/Integration/Form/BAGIVA.vue';
import KlikBCA from '@/pages/Integration/Form/KlikBca.vue';
import Others from '@/pages/Integration/Form/Others.vue';
import Others2 from '@/pages/Integration/Form/Others2.vue';

@Component({
  components: {
    LayoutContent,
    Button,
    BAGIVA,
    BcaVA,
    BriVA,
    MandiriBP,
    BniVA,
    BncVA,
    DanamonVA,
    MaybankVA,
    PermataVA,
    KlikBCA,
    Others,
    Others2,
  },
})
export default class PaymentChannelSetting extends Vue {
  @Prop(String) serviceCode!: string;
  @Prop(String) channelID!: string;
  @Prop(String) secretKey!: string;
  @Prop() itemData!: any;
  @Prop(String) phase!: string;

  redirectPayment = [
    '1022',
    '1023',
    '1081',
    '1061',
    '1041',
    '1077',
    '1083',
    '1084',
    '1085',
    '1024',
    '1073',
    '1080',
    '2002',
  ];
}
